module.exports = __webpack_public_path__ + "img/wechat.ae261c1d.png";